import { Card, Spacer } from '@nextui-org/react';

import Image from 'next/image';
import Bismillah from '../components/Bismillah';
import CardPageContainer from '../components/CardPageContainer';
import Footer from '../components/Footer';
import Header from '../components/Header';
import InnerCardPageContainer from '../components/InnerCardPageContainer';
import Layout from '../components/Layout';

export default function Donate() {
  return (
    <Layout>
      <Header description="Find out how to support Thaqalayn" title="Support Thaqalayn" />
      <CardPageContainer>
        <InnerCardPageContainer>
          <Card className="single-card" role="article">
            <div className="card-body mt-2 mb-2">
              <Bismillah />
              <h1 className="text-xl font-bold">Support Us</h1>
              <p>
                Please consider donating to support this project, Thaqalayn Hadith Library is non-profit and all funds
                will be used to cover the costs of the server, development, app store licenses and to pay for
                translation commissions so we can keep adding more educational content to the website.
              </p>
              <p>You can make a one-time or recurring donation through PayPal using the following link:</p>
              <div className="flex flex-row justify-center">
                <a
                  href="https://www.paypal.com/donate/?hosted_button_id=W7YZMHD9RB3FW"
                  rel="noreferrer"
                  target="_blank"
                >
                  <Image
                    alt="Donate with PayPal"
                    className="hover:scale-110 ease-in-out duration-200"
                    height={50}
                    src="/paypal.png"
                    width={210}
                  />
                </a>
              </div>
              <br />
              <p>The translations which we have been able to to complete through the support of your donations are:</p>
              <ul className="list-disc">
                <li className="ml-4">
                  Al-Amālī by Shaykh Muḥammad b. ʿAlī al-Ṣaduq (d. 381 AH) | translated by Bilal Muhammad
                </li>
                <li className="ml-4">
                  Maʿānī al-ʾAkhbār by Shaykh Muḥammad b. ʿAlī al-Ṣaduq (d. 381 AH) | translated by Basel Kadem
                </li>
              </ul>
              <br />
              <p>
                In addition to the commisioned translations the mobile application (iOS & Android) has also been funded
                fully by the donations that were raised. You can find it in the Apple Appstore and Google Play:
              </p>
              <div className="flex flex-row justify-center align-middle">
                <a
                  className="my-auto"
                  href="https://play.google.com/store/apps/details?id=com.thaqa.book_app"
                  rel="noreferrer"
                  target="_blank"
                >
                  <Image
                    alt="Google Play Store"
                    className="hover:scale-110 ease-in-out duration-200"
                    height={50}
                    src="/play-store.png"
                    width={230}
                  />
                </a>
                <a
                  className="my-auto"
                  href="https://apps.apple.com/app/thaqalayn-hadith-library/id1632308350"
                  rel="noreferrer"
                  target="_blank"
                >
                  <Image
                    alt="Apple App Store"
                    className="hover:scale-110 ease-in-out duration-200"
                    height={200}
                    src="/appstore.png"
                    width={210}
                  />
                </a>
              </div>
              <Spacer y={1} />
              <Card.Divider />
              <p>
                Also consider buying a printed copy of the translations available on the website to support their
                translators & publishers, you can find them on these bookshops:
              </p>
              <ul className="list-disc">
                <li className="ml-4">
                  <a href="https://www.houseoftaha.com/" rel="noreferrer" target="_blank">
                    House of Taha (UK)
                  </a>
                </li>

                <li className="ml-4">
                  <a href="https://www.hujjatbookshop.co.uk/" rel="noreferrer" target="_blank">
                    Hujjat Bookshop (UK)
                  </a>
                </li>

                <li className="ml-4">
                  <a href="https://al-buraq.org/" rel="noreferrer" target="_blank">
                    Al-Buraq (US)
                  </a>
                </li>

                <li className="ml-4">
                  <a href="https://www.shiabooks.com.au/" rel="noreferrer" target="_blank">
                    Shia Books (AU)
                  </a>
                </li>
              </ul>
            </div>
          </Card>
        </InnerCardPageContainer>
        <Footer />
      </CardPageContainer>
    </Layout>
  );
}
